import { log, warn, error } from "modules/logs"

export const dispatchEvent = (eventName, detail = {}) => {
  log("web > native | dispatchEvent", eventName, JSON.stringify(detail))

  const event = new CustomEvent(eventName, { detail })
  window.dispatchEvent(event)
}
